import { Translation } from './constants';

export const en: Translation = {
	loginText: 'Raw material prices à la carte',
	forgotYourPassword: 'Forgot password?',
	signUp: 'Sign up',
	eMail: 'E-Mail',
	registered: 'Registered',
	customerNr: 'Customer Nr.',
	freemium: 'Freemium',
	customer: 'Customer',
	animateWidgetLine: 'Animated Dashboard Widgets',
	showPartnerLinkLine: 'Show Partner Section in Nav Bar',
	animation: 'Animations',
	personalize: 'Personalization',
	searchMaterialEtc: 'Search by material, etc.',
	searchNewsEtc: 'Search by news, etc.',
	noTendersSaved: 'No tenders saved',
	noEarlyProjectInfoSaved: 'No early project information saved',
	tendersAndMore: 'Tenders & more',
	frozen: 'Frozen',
	unfreeze: 'Unfreeze',
	freeze: 'Freeze',
	adminDownloadIntraday: 'Admin Download (Intr.)',
	passwordConfirmation: 'Password Confirmation',
	clickHereTo: 'Click here to',
	forgotPasswordWaitMessage:
		'If your email address is known, then you will receive an email from us in the next few minutes. If you do not receive an email after 5 minutes, then please also check your spam folder. Alternatively, you can also contact customer service.',
	oldPasswordIsRequired: 'Old password is required',
	passwordMatch: 'New password & confirm new password do not match!',
	spaceNotExists: 'Space should not exists',
	passwordCriteria: 'Your password must meet the following criteria:',
	oneSpecialChar: 'Min. 1 special character',
	oneNumberValidation: 'Min. 1 number',
	oneUppercaseOneLowercase: 'Min 1 capital and 1 small letter',
	atLeast8Characters: 'Min 8 & Max 24 characters',
	matfoxxSettings: 'Matfoxx settings',
	matfoxxNotifications: 'Notifications',
	matfoxxNotificationOff: 'Off',
	matfoxxNotificationOn: 'On',
	notificationPeriod: 'Notification period',
	notificationAutomatically: 'Automatically',
	until: 'Until',
	filterNotifications: 'Filter notifications',
	quoteOTheDay: 'Quote of the day',
	matflixxOffers: 'Matflixx offers',
	updateGroup: 'Update group',
	subGroup: 'Sub Group',
	deleteCourseList: 'Are you sure you want to delete this item..?',
	createGroup: 'Create Group',
	editModelParameters: 'Edit model parameters',
	addToCostModel: 'Add to Cost Model',
	matflixxModals: 'Matflixx models',
	addMatflixxModals: 'Add Matflixx models',
	customizeCostModel: 'Customize Cost Model',
	sinceOneYear: 'Since 1 year',
	sinceOneQuater: 'Since 1 quarter',
	sinceOneMonth: 'Since 1 month',
	shares: 'Shares',
	priceDriver: 'Price Driver',
	share: 'Share',
	updateOnDashboard: 'Update on Dashboard',
	myCostModel: 'My Cost Model',
	dashboard: 'Dashboard',
	customize: 'Customize',
	favorites: 'Favorites',
	myData: 'My data',
	myDashboard: 'My dashboard',
	noUserFound: 'No user found',
	myNewsAndForecast: 'My news and forecasts',
	designation: 'Designation',
	addShortcut: 'Add a new shortcut',
	myShortcut: 'My Shortcuts',
	pleseSelectFieldMessage: 'Please fill this field',
	targetUrl: 'Target URL',
	enterValidUrlAddress: 'Enter valid URL address',
	urlForLogoPriview: 'URL for Logo or Preview (optional)',
	rawMaterials: 'Raw Materials',
	news: 'News',
	selectedMaterials: 'Selected materials',
	selectedNews: 'Selected news',
	addWidgetToDashboard: 'Add widget to dashboard',
	update: 'Update',
	submit: 'Submit',
	delete: 'Delete',
	edit: 'Edit',
	showAll: 'Show All',
	date: 'Date',
	price: 'Price',
	change: '%-Change',
	latestNews: 'Latest news',
	addWidget: 'Add widget',
	allSectors: 'All sectors',
	collapsePanel: 'Collapse panel',
	noCourseListing: 'No course listings',
	convert: 'Convert',
	addToDashboard: 'Add to dashboard',
	exportCorseListAsExcel: 'Export Data as Excel',
	advanceSearchForCourses: 'Advanced search for courses',
	seek: 'Search',
	searchPatterns: 'Search patterns / words',
	advanceSearchPlaceHolder: 'Minimum 3 character such as "electricity"',
	duration: 'Duration',
	doNotMetter: `Doesn't matter`,
	withoutDueDate: 'Without due date',
	withoutFutures: 'Without futures',
	futurePerptualContracsOnly: 'Future endless contracts only',
	futureWithoutEndlessContract: 'Futures without endless contracts',
	back: 'Back',
	materials: 'Materials',
	addFilterToDashboard: 'Add filters to dashboard',
	chooseDateRange: 'Choose date range',
	cancel: 'Cancel',
	searchNews: 'News',
	searchNewsMaterialEtc: 'Search by news, prices, etc.',
	all: 'All',
	noEntriesFound: 'No results found',
	tryUsingDiffKeyword: 'Try using different keywords',
	more: 'More...',
	notification: 'Notification',
	profile: 'Profile',
	logout: 'Logout',
	login: 'Log in',
	emailAddress: 'E-Mail-Address',
	password: 'Password',
	exportHistoryAsCSV: 'Export as CSV',
	exportDataAsExcel: 'Export as Excel',
	add: 'Add',
	maturityOverview: 'Maturity overview',
	exportPriceAsExcel: 'Export price as Excel',
	addWidgetToScreeen: 'Add to widget screen',
	setUpPriceAlert: 'Set up price alert',
	addChartToDashboard: 'Add chart to dashboard',
	courseListings: 'Course lists',
	renameCourseList: 'Rename course list',
	rename: 'Rename',
	extinguish: 'Delete',
	newsFilterTags: 'News Filter / Tags',
	alerts: 'Alerts',
	notifyAtTime: 'Notify at ... time (optional) ',
	noteMessageForAllKeywordAppears: 'Note: The notification only occurs if all keywords appear in a message!',
	addNews: 'New Alert',
	currnetCourse: 'Current course',
	reportIf: 'Alert when',
	courseExceeded: 'Course exceeded',
	courseUndershot: 'Course undershot',
	absPerDeviationExceeded: '% positive deviation',
	comparativeValue: 'Comparative value',
	dateOfExpiry: 'Expiration date',
	addCourseAlert: 'Add alert',
	messageAlerts: 'Message alerts',
	keywords: 'Keywords',
	exmpleEleGas: 'e.g. electricity gas',
	forecasts: 'Forecasts',
	pdfModule: 'My PDFs',
	name: 'Name',
	noNewsHeading: 'No news headings...',
	createNewPriceList: 'Create a new price list',
	addAnotherOneLanguage: 'Add another language',
	view: 'View',
	uploadFile: 'Upload file',
	maturity: 'Maturity',
	symbol: 'Symbol',
	visible: 'Visible',
	notVisible: 'Not Visible',
	pricesTime: 'Prices time',
	selectAll: 'Select all',
	hideSelected: 'Hide selected',
	deleteSelected: 'Delete selected',
	editUserData: 'Edit user data',
	save: 'Save',
	generalInfo: 'General info',
	salutation: 'Salutation',
	mr: 'Mr',
	ms: 'Ms',
	surname: 'Surname',
	company: 'Company',
	contacts: 'Contacts',
	phoneNumber: 'Phone number',
	email: 'E-mail',
	permissionData: 'Permission data',
	status: 'Status',
	active: 'Active',
	admin: 'Admin',
	inactive: 'Inactive',
	validUntill: 'Valid until',
	apiInterfaceActive: 'API interface active',
	apiKey: 'API-key',
	comment: 'Comment',
	superAdminMessage: 'Super admin',
	// , i.e. allowed to change admins and special tables',
	adminMessage: 'User Admin',
	// , i.e. is allowed to change users and user rights, as well as everything that editors / editors are	allowed',
	allMaterials: 'All materials',
	myMaterials: 'My materials',
	search: 'Search',
	saveMessage: 'Saved News',
	constModels: 'Cost Models',
	courses: 'Courses',
	dataProcessorMessage: 'Data Admin',
	// , i.e. allowed to change course, histories and mbi course lists',
	editorMessage: 'Editor',
	// , i.e. allowed to change and delete messages',
	API: 'API',
	statistics: 'Statistics',
	validity: 'Validity',
	markant: 'Distinctive',
	manageData: 'Manage data',
	permission: 'Permission',
	ownDataUpload: 'Own data upload',
	invisible: 'Invisible',
	whiteLabelAdmin: 'Whitelabel users',
	groupName: 'Group name',
	files: 'Files',
	addFile: 'Add file',
	dragAndDropToUploadFile: 'Drag & Drop to upload file',
	uploaded: 'Uploaded',
	timeLimit: 'Time limit',
	occurred: 'Occurred',
	deactive: 'Deactive',
	isin: 'ISIN',
	exchange: 'Exchange',
	dataProvider: 'Data provider',
	source: 'Source',
	cpCustomer: 'CP Customer',
	courseTime: 'Course time',
	country: 'Country',
	currency: 'Currency',
	pleaseSelectACategory: 'Please select a category',
	chooseCountry: 'Choose country',
	runTime: 'Runtime',
	chooseCurrency: 'Choose currency',
	advanceSearchfForPrice: 'Advance search for prices',
	advanceSearchTableText: 'There are more prices matching your search. Scroll forward. However, a maximum of 200 results are displayed.',
	advanceSearchTableDescription:
		'Enter more search words to refine the result and narrow the search. Also use abbreviations or DIN / AISI codes. Vary between the German and English names. Or put a minus in front of words, e.g.- Germany, to exclude price data that have this word in the name.',
	tip: 'Tip',
	line: 'Line',
	area: 'Area',
	candle: 'Candle',
	chartType: 'ChartType',
	indicators: 'Indicators',
	span: 'Span',
	addToPrice: 'Add to my materials',
	currentPrice: 'Current price',
	alertCurrency: 'Currency',
	addedToDashboard: 'Added to dashboard!',
	updatedToDashboard: 'Updated on Dashboard!',
	exportData: 'Export data',
	selectFileFormat: 'Select the file format',
	users: 'Users',
	general: 'General',
	data: 'Data',
	whiteLabel: 'Whitelabel',
	matfoxx: 'Matfoxx',
	advancedSearchResult: 'The search returns no results.',
	profileData: 'Profile & Data',
	profileInfo: 'Profile info',
	profileSaveChanges: 'Save changes',
	profilePhoto: 'Profile photo',
	profileAddFile: 'Add file',
	profileDragandDrop: 'or Drag & Drop here',
	profileSavePhotos: 'Save photo',
	profileDeletePhotos: 'Delete photo',
	profileGeneralData: 'General data',
	profileCurrentEmail: 'Current email address',
	profileChangePassword: 'Change password',
	advancedSearchTip:
		'Tip: Enter more search words to refine the result and narrow the search. Also use abbreviations or DIN / AISI codes. Vary between the German and English names. Or precede words with a minus sign, eg - Germany, to exclude price dates that have this word in the name.',
	adminDownloadHistory: 'Admin download (Hist.)',
	addToMbiList: 'Add to MBI price list',
	assignMaterialToUser: 'Assign material to a user',
	dataEditing: 'Data editing',
	addCourseToCourseList: 'Add a course to a course list',
	myMaterialsEmptyTitle: 'This price list is empty!',
	myMaterialEmptyDescription:
		'To add materials or prices to this price list, please select a material/price using the search function or via Open all materials and then click on "Add to a price list". Then select the name of this price list.',
	searchUsers: 'Search users',
	registerNow: 'Register',
	city: 'City',
	position: 'Position',
	postcode: 'Postcode',
	required: 'Required',
	firstname: 'First name',
	download: 'Download',
	imprint: 'Imprint',
	settings: 'Settings',
	abort: 'Cancel',
	takeOver: 'Apply',
	removed: 'Remove',
	days: 'Days',
	setPeriod: 'Set period',
	onboardSecondTitle: 'Which form of presentation do you prefer?',
	createPassword: 'Create Password',
	futures: 'Futures',
	masterExportExcel: 'Master data download',
	enterValuesGreaterThan: 'Enter value greater than',
	enterValuesLessThan: 'Enter value less than',
	comparisonValues: 'Comparison value must be between 0 - 100',
	comparisonValueGreaterThanZero: 'Comparison value must be greater than zero',
	numberIsTooBig: 'Number is too big',
	courseDifference: 'Procentual deviation of the course exceeded',
	selectFromTheDropDown: 'Please select from the dropdown',
	title: 'Title',
	url: 'URL',
	urlplaceholder: 'https://...',
	registrationValidationType: 'Invalid type',
	addShortCutDeleteLink: 'Delete link',
	comparativeSearchPlaceholder: 'Comparative value search',
	month: 'Month',
	months: 'Months',
	year: 'Year',
	custom: 'Custom',
	emptyChartMessage: 'Unfortunately, data could not be loaded because the last course is more than a year old!',
	ema: 'Exponential Moving Average (EMA)',
	sma: 'Simple Moving Average (SMA)',
	bb: 'Bollinger Bands (BB)',
	tma: 'Triangular Moving Average (TMA)',
	wma: 'Weighted Moving Average (WMA)',
	atr: 'Average True Range (ATR)',
	rsi: 'Relative Strength Index (RSI)',
	macd: 'Moving Average Convergence/Divergence (MACD)',
	sto: 'Stochastic Oscillator (STO)',
	lowDataChartMessage: 'No or too few courses!',
	choose: 'Choose',
	noAlertFound: 'No alert found',
	loadingChartData: 'Loading chart data...',
	deleteDashboardWidget: 'Sure you want to delete this item?',
	positiveDifference: '% positive deviation',
	negativeDifference: '% negative deviation',
	updateChartToDashboard: 'Update chart on dashboard',
	day: 'Day',
	daily: 'Daily',
	weekly: 'Weekly',
	monthly: 'Monthly',
	updateToDashBoard: 'Update to dashboard',
	addMaterials: 'Add materials',
	addNewsAndForecast: 'Add news and forecasts',
	unlimited: 'Unlimited',
	markAllAsRead: 'mark all as read',
	otherChanges: 'Other changes',
	materialAlert: 'Material Alerts	',
	newslAlert: 'News Alerts',
	actual: 'Current',
	hist: 'Historic',
	high: 'High',
	low: 'Low',
	histDate: 'Hist. Date',
	unit: 'Unit',
	kurszeit: 'Date',
	dueDate: 'Due Date',
	mbiListPlaceHolder: 'Set caption',
	isRequired: 'is required!',
	confirmLogout: 'Are you sure, you want to logout?',
	yes: 'Yes',
	no: 'No',
	faq: 'FAQ',
	almostThere: 'Almost there!',
	weNeedInfo: 'We just need a little more information.',
	bis: 'To',
	von: 'From',
	protocol: 'Protocol',
	categoryIncludeMessage: 'This material is included in the following price lists :',
	userIsAdminMessage: 'The user {{userName}} is an admin and can see everything anyway, so no data is displayed here.',
	editNews: 'Edit News',
	deleteNews: 'Delete News',
	adminPriceDownload: 'Admin Price Download',
	userId: 'User Id',
	uploadedBy: 'Uploaded By',
	fileName: 'Filename',
	inserted: 'Inserted',
	updated: 'Updated',
	processes: 'Processes',
	mistake: 'Mistake',
	noGroup: 'No Group',
	enterEmail: 'Please enter valid email',
	forgotPasswordNote: 'If you request a new password, you will receive an email from us with a link to set a new password.',
	requestNewPassword: 'Request new Password',
	alreadyRegistered: 'If you are already registered, then',
	here: 'here',
	notSubscribeYet: 'You are not subscriber yet? Then',
	register: 'Register',
	now: 'now',
	passwordForgotten: 'Password forgotten',
	testForFree: 'and test Matflixx for free.',
	noSavedNewsFound: 'You have not marked any messages...',
	saveChanges: 'Save changes',
	discard: 'Discard',
	lastName: 'Last name',
	removeFromDashboard: 'Removed from Dashboard',
	noMaterialFound: 'No material found',
	takeOverAccount: 'Take over',
	takeOverFirstMessage: 'You have taken over this user account. Changes you make actually affect the customer account. Click',
	takeOverSecondMessage: ', to return to your account.',
	newsSections: 'News sections...',
	itemChoosen: 'items chosen.',
	group: 'Group',
	authorized: 'Authorized',
	mainCourse: 'Main course',
	alertWhen: 'Alert when',
	entered: 'Entered',
	newsFilterKeyWords: 'News Filter / Keywords',
	deleteAlertMessage: 'Do you want to delete the rate monitoring for {{alert}} ?',
	visibility: 'Visibility',
	hidden: 'Hidden',
	addPartnersLink: 'Add partners link',
	assign: 'Assign',
	create: 'Create...',
	savedNews: 'Saved news.',
	shortcutCreated: 'Added shortcut.',
	shortcutUpdated: 'Applied changes.',
	shortcutDeleted: 'Shortcut deleted.',
	widgetSwiped: 'The position of the elements has been changed.',
	grantPermissionToUser: 'The user rights have been updated!',
	deleteNewsArticle: 'Article deleted.',
	deleteFromCourseList: 'Entry deleted from the course list!',
	addedToList: 'Added to the list!',
	forgotPassword: 'Forgot password',
	priceListIsEmpty: 'This price list is empty!',
	emptyPriceListMessage:
		'To add materials or prices to this price list, please select a material/price using the search function or use "All materials" and then click on "Add to a price list". Then select the name of this price list.',
	deleteNewsPopupMessage: 'Are you sure you want to delete news?',
	validUrlErrorMessage: 'Please enter valid URL',
	addInformation: 'Add information',
	enterNote: 'Enter note',
	choosePriority: 'Choose priority',
	normal: 'Normal',
	critical: 'Critical',
	editInformation: 'Edit information',
	authorizationElement: 'Authorization element',
	userList: 'User list',
	masterData: 'Master data',
	backpack: 'Backpack',
	createNewBackpack: 'Create a new backpack',
	editBackpack: 'Edit backpack',
	downloadMasterData: 'Download master data',
	comparisionValueShouldNotBeEmpty: 'Comparision value should not be empty',
	reset: 'Reset',
	whiteLabelFormTitle: 'Change UI color',
	colors: 'Colors',
	courseListNameHasBeenSaved: 'Course list name has been saved!',
	courseListDeleted: 'Course list deleted',
	noCurrentData: 'No current data ',
	maximumLimitReached: 'Maximum limit reached',
	noNewsArticleFound: 'No matching news found.',
	searchingNewsArticles: 'Searching for news',
	additionalInfo: 'Additional info',
	chartUpdateDaily: 'Daily',
	chartUpdateWeekly: 'Weekly',
	chartUpdateMonthly: 'Monthly',
	listName: 'List name',
	partnerLinks: 'Partner links',
	addAlertDropDownPlaceholder: 'Select...',
	glossary: 'Glossary',
	normalization: 'Normalization',
	myModels: 'My models',
	exportAsExcel: 'Export data as Excel',
	exportAsCSV: 'Export history as CSV',
	createNewCostModel: 'Create new Cost Model',
	noDataFound: 'No data found',
	modalName: 'Model Name',
	sectors: 'Sectors',
	makeThisModelVisible: 'Make this model visible',
	ingridients: 'Ingredients',
	number: 'No.',
	componentName: 'Component Name',
	amount: 'Amount',
	ratio: 'Ratio',
	total: 'Total',
	saveAsDraft: 'Save as draft',
	createCostModel: 'Create Cost Model',
	upload: 'Upload',
	listofOffers: 'List of offers',
	addNewsDashboard: 'Add news',
	matfoxxOffersFormHeader: 'Displayed text, action, duration',
	fileHasBeenUploaded: 'File has been uploaded',
	enterTheOfferText: 'Enter the offer text',
	enterValue: 'Enter value',
	text: 'Text',
	link: 'Link',
	jokes: 'Jokes',
	enterJoke: 'Enter a joke',
	listOfJokes: 'List of jokes',
	jokeOfTheDay: 'JOKE OF THE DAY',
	offerOfTheDay: 'OFFER OF THE DAY',
	heading: 'Heading',
	entry: 'Entry',
	listOfAnnouncements: 'List of announcements',
	loadMore: 'Load more',
	allDocuments: 'All documents',
	editPrice: 'Edit price',
	howWouldYouLikeToProceed: 'How would you like to proceed?',
	generateDashBoardAuomatic: 'Generate a Dashboard automatically',
	customerServiceAssistence: 'Customer service assistance',
	createYourOwnDashboard: 'Create your own Dashboard',
	balancedDashboard: 'Balanced Dashboard',
	graphicalDashboard: 'Graphical Dashboard',
	analyticalDashboard: 'Analytical Dashboard',
	next: 'Next',
	addNewForecast: 'Add a new forecast',
	addNewPdfModule: 'Add a new PDF',
	pleaseUploadFileFirst: 'Please upload file first*',
	oldPassword: 'Old password',
	newPassword: 'New password',
	confirmNewPassword: 'Confirm new password',
	passwordChanged: 'Password changed',
	forgotPasswordMailSendMessage: `We'll email you within minutes.`,
	sector: 'Sector',
	category: 'Category',
	imageSources: 'Image sources',
	chartUpdateQuarterly: 'Quarterly',
	forecastDelete: 'forecast deleted!',
	pdfModuleDelete: 'PDF deleted!',
	week: 'Week',
	prices: 'Prices',
	logarithmicYAxis: 'Logarithmic Y-axis',
	informations: 'Informations',
	frequency: 'Frequency',
	stockExchange: 'Stock exchange',
	dataAvailability: 'Data availability',
	addInfo: 'Add. info',
	addedOn: 'Added on',
	endedOn: 'Ended on',
	graphicDownload: 'Export graphics',
	adminDownloadForecast: 'Admin download (Forecast)',
	adminDownloadPdfModule: 'Admin download (PDF)',
	default: 'Default',
	inventoryChart: 'Inventory chart',
	forwardCurve: 'Forward curve',
	uploadActiveSVG: 'Upload active SVG Icon',
	uploadInActiveSVG: 'Upload in-active SVG icon',
	tenders: 'Tenders',
	saveTenders: 'Saved tenders',
	projectEarlyInformation: 'Early project information',
	countries: 'Countries',
	noTenderArticleFound: 'No tenders found',
	created: 'Created',
	validFrom: 'Valid from',
	validTo: 'Valid to',
	deadLine: 'Deadline',
	financing: 'Financers',
	gtaiId: 'GTAI ID',
	projectName: 'Project name',
	referenceNr: 'Reference number',
	latestTenders: 'Latest tenders',
	tenderAlerts: 'Tenders alerts',
	tenderFilterKeywords: 'Tender filter / keywords',
	attachment: 'Anhänge',
	noSavedTenders: 'You have not saved any tenders...',
	chartSettings: 'Chart settings',
	left: 'Left',
	right: 'Right',
	color: 'Color',
	indicator: 'Indicator',
	history: 'History',
	axis: 'Axis',
	short: 'Short',
	long: 'Long',
	advancedSettings: 'Advanced settings',
	signal: 'Signal',
	duplicateChartTooltipMessage:
		'Duplicates the rate to make historical comparisons in the year period or comparisons in different currencies with the already selected material / data set.',
	defaultTooltipMessage: 'Charting of price data',
	indicatorTooltipMessage: 'Selection of the indicators to be used. Several indicators can be used simultaneously.',
	axisTooltipMessage: 'Position of the Y-axis',
	historyTooltipMessage: 'Selection of history by year',
	emaToolTipMessage: 'Average asset price, new and recent data points/prices carry greater weight.',
	smaToolTipMessage: 'Average price of an asset/security over a specific period of time.',
	stoToolTipMessage: 'A closing price of a security is compared to a range of its prices over a period of time.',
	macdToolTipMessage: 'An indicator to understand the momentum and directional strength of a security.',
	rsiToolTipMessage: 'Measures the speed and change of price movements.',
	bbToolTipMessage: 'Technical analysis tool.',
	tmaToolTipMessage: 'The average of the SMA. Wont react quick to volatile market conditions.',
	wmaToolTipMessage: 'Assigns a heavier weight to current data points.',
	atrToolTipMessage: 'Used to measure a securities price movement and based on absolute values.',
	changeToolTipMessage: 'Charting of the change from the previous data point',
	LogarithmicYAxisTooltipMessage: 'Allows better visualization of high amounts',
	exportFormat: 'Export format',
	grouping: 'Grouping',
	sorting: 'Sorting',
	allData: 'All data',
	intraday: 'Intra day',
	yearly: 'Yearly',
	value: 'Value',
	mustBeNumber: 'must be a number',
	chartUpdateYearly: 'Yearly',
	numberTableHeader: 'Numbers',
	shortCustom: 'custom.',
	standard: 'Standard',
	advanced: 'Advanced',
	ascending: 'Ascending',
	descending: 'Descending',
	standardInfo: 'Contains price data and chart',
	advancedInfo: 'Standard export expanded to include additional data (if available), such as percentage change and forwards',
	dailyInfo: 'Export of daily data points or closing price of intraday prices',
	intradayInfo: 'Export of all price data within a trading day',
	weeklyInfo: 'Export of weekly data points or weekly averages of the available data',
	monthlyInfo: 'Export of monthly data points or monthly averages of the available data',
	ascendingInfo: 'Sorting from oldest to newest data point',
	descendingInfo: 'Sorting from newest to oldest data point',
	bar: 'Bar',
	barChartErrorMessage: 'Percentage change only visible in the line chart',
	barChartNumberValidationMessage: 'Bar chart only supports a maximum of 3 comparison prices',
	generatingChartImages: 'Generating chart images...',
	intraDayInfo: 'Export of all price data within a trading day',
	years: 'Years',
	none: 'None',
	dataNotIncludedInSubscription: 'This data is not currently included in your subscripton.',
	pleaseSelectAllHistoryDropdown: 'Histories can only be compared to other histories.',
	noEnoughDataToPlot: 'Not enough data to plot.',
	createNewGroup: 'Create a new group',
	groupManagement: 'Group management',
	addNewGroup: 'Add new group',
	promotionCode: 'Promotion Code',
	selectUser: 'Select user',
	selectBackpack: 'Select backpack',
	selectWhiteLabel: 'Select white label',
	groups: 'Groups',
	editGroup: 'Edit Groups',
	customMailCommunication: 'Custom mail communication',
	adjustMailTemplate: 'Adjust Mail Templates',
	chooseUser: 'Choose user',
	fileUploadSuccessMessage: 'File upload successfully',
	noWhiteLabelFoundErrorMessage: 'No whitelable found! Please click on "+" to create a new one.',
	registration: 'Registration',
	projectAlerts: 'Project alerts',
	copyToClipboard: 'Copied to Clipboard',
	somethingWentWrong: 'Something went wrong :confused:',
	phone: 'Phone',
	foreignTradeNews: 'Foreign Trade News',
	financers: 'Financers',
	deleteUser: 'Delete user',
	deleteUserMessage: 'To delete the user type in “DELETE”',
	deleteMyMaterialConfirmationMessage: ' Are you sure you want to remove material?',
	deleteMyMaterialListEntriesConfirmationMessage: 'Are you sure you want to delete list?',
	groupName50CharacterValidation: 'Group name must be at most 50 characters',
	groupNameWhiteSpaceValidationMessage: 'Group name cannot have more than one whitespace between words',
	userDashboard: 'User Dashboards',
	dashboardAssignSuccessfully: 'Dashboard assigned successfully!',
	myMaterialListTransferredSuccessfully: 'My material list transferred successfully',
	transfer: 'Transfer',
	acceptAtmax10Numbers: 'Accept at-max 10 numbers',
	firstNameCharacterLengthValidation: 'First name must be at most 30 characters',
	lastNameCharacterLengthValidation: 'Last name must be at most 30 characters',
	germanNameCharacterLengthValidation: 'German name must be at most 50 characters',
	englishNameCharacterLengthValidation: 'English name must be at most 50 characters',
	reports: 'Reports',
	allReports: 'All Reports',
	matflixxForecast: 'Matflixx Forecasts',
	matflixxPdfModule: 'Matflixx PDFs',
	allForecasts: 'All Forecasts',
	allPdfModule: 'All PDFs',
	clearAll: 'Clear All',
	moveWidgetHere: 'Move widget here',
	deleteBackPackMessage: 'To delete the backpack type in “DELETE”',
	inActivityMessage: 'You have been logged out due to inactivity. Please log in again.',
	otherDeviceLoginMessage: 'It appears that you are using Matflixx on a different device. For more information, please contact customer service.',
	matflixxSectors: 'Matflixx sectors',
	imageValidationMessage: 'File size is too large. Please select an attachment which is less than 1 MB.',
	imageFormateValidationMessage: 'Unsupported file format. Only JPEG, JPG, and PNG formats are supported.',
	germanName: 'German name',
	englishName: 'English name',
	activeIcon: 'Active icon',
	inActiveIcon: 'In-active icon',
	customMaterialStructure: 'Custom material structure',
	customNewsStructures: 'Custom news structure',
	customForecastStructure: 'Custom Forecast structure',
	customPdfModuleStructure: 'Custom PDF structure',
	activePlusOriginal: 'active (+show original)',
	hideAll: 'Hide all',
	actualData: 'Actual data',
	deleteBackpack: 'Delete Backpack',
	chooseMasterData: 'Choose Master Data',
	chooseSource: 'Choose Source',
	enterSourceName: 'Enter source name',
	exportVisibleMaterialOnly: 'Export visible materials only',
	alsoExportFuturesContracts: 'Also export futures contracts',
	exportCsv: 'Export as CSV',
	exportExcel: 'Export as Excel',
	devices: 'Devices',
	lastLogin: 'Last log-in',
	minutes: 'Minutes',
	dailyActiveUsers: 'Daily active user',
	monthlyActiveUsers: 'Monthly active user',
	weeklyActiveUsers: 'Weekly active user',
	totalUsers: 'Total user',
	newUsers: 'New user',
	averageTimeSpend: 'Average time spent',
	averagePageVisits: 'Average page visits',
	downloadFilesheet: 'Download filesheets',
	currencies: 'Currencies',
	units: 'Units',
	countriesAndRegions: 'Countries & Regions',
	notations: 'Notations',
	tendersCountries: 'Tenders countries',
	askMeSomething: 'Ask me something',
	logins: 'Logins',
	customerSince: 'Customer since',
	freemiumSince: 'Freemium since',
	language: 'Language',
	triggered: 'Triggered',
	newsAlert: 'News Alert',
	tenderAlert: 'Tender Alert',
	projectAlert: 'Early Project Information Alert',
	priceAlert: 'Course Alert',
	and: '+ AND',
	or: '/ OR',
	latestNewsAlert: 'Latest news alert',
	latestTendersAlert: 'Latest tenders alert',
	categories: 'Categories',
	alreadyAddedDashboard: 'Already added dashboard!',
	latestPJEAlert: 'Latest PJE alert',
	comparison: 'Comparison',
	startDate: 'Start-Date',
	endDate: 'End-Date',
	invalidFileTypeMessage: 'Please upload csv. xlxs. file',
	dataUpload: 'Data Upload',
	errors: 'Errors',
	newsAlertValidation: 'Either keyword or category is required!',
	atLeastOneFieldRequired: 'At least one field is required!',
	eexForecast: 'EEX Forecasts',
	mbiForecast: 'MBI Forecasts',
	changeCurrency: 'Change',
	materialGroup: 'Material Group',
	enterCorrectEmailAddress: 'Please enter a correct e-mail address',
	reqNewPasswordText: 'If you request a new password, you will receive an e-mail from us with a link to set up a new password.',
	reqNewPassword: 'Request new password',
	invalidLoginCredentials: 'The email address or password is incorrect.',
	alreadyRegisteredText: 'If you are already registered, log in',
	an: '',
	notASubscriberText: 'Not yet a subscriber?',
	forgotPasswordRegister: 'register',
	forgotPasswordNow: '',
	trayMatflixxForFree: 'now and test Matflixx for free.',
	knownEmailAddressText:
		'If your e-Mail address is known, you will receive an e-Mail from us within the next few minutes. If you have not received an e-mail after 5 minutes, please also check your spam folder. Alternatively, you can also contact customer service',
	priceUpdate: 'Price updates',
	newPrice: 'New Prices',
	masterDataUpdate: 'Master Data Updates',
	newMasterData: 'New  Master Data',
	includeForecast: 'Include Forecast',
	include: 'include',
	exclude: 'exclude',
	errorOne: 'Issue with column header, could be caused by a typo, e.g., “simbol” instead of “symbol”.',
	errorTwo: 'Critical entry missing. Critical entries: symbol; boerse.',
	errorThree: 'Date format does not match allowed date formats.',
	errorFour: 'Number format can’t be computed, e.g., entry does not only contain numbers.',
	errorFive: 'Filename can’t be computed by the system',
	errorSix: 'Filetype can’t be computed by the system',
	errorSeven: 'Currency is not an entry in the currency sheet',
	errorEight: 'Unit is not an entry in the unit sheet',
	errorNine: 'Value exceeds %-Change value',
	start: 'Start',
	end: 'End',
	unKnownError: 'Unknown Error',
	advanceSearchText: 'Search the database for results',
	lockForecastText: 'To view forecasts, please contact customer service',
	currencyDefaultTooltipMessage: 'For the standard currency conversion we use the Forex values',
	currencyBloombergTooltipMessage: 'For Bloomberg we only offer the EUR/USD Fixing Frankfurt 14.00, BFIX rate',
	currencyTooltipMessage: 'If you want to use a different exchange rate, select the desired source in the advanced settings',
	lme: 'LME',
	bloomberg: 'Bloomberg',
	ecb: 'ECB',
	currencyConversion: 'Currency Conversion',
	chartView: 'Chart View',
	categoryInfo:
		'Define a specific message category to increase the accuracy of your search. If no category is selected, the search is carried out in all categories. Then select further categories if necessary. You can then select the “AND” or “OR” search. Click on the word “AND” or “OR” to change the search mode.',
	countryInfo:
		'Select the countries for which you want your alerts to be relevant. Only results from these countries will be included in your alerts. Then select additional countries if necessary. You can then select the “AND” or “OR” search. Click on the word “AND” or “OR” to change the search mode.',
	sectorInfo:
		'Specify which sectors or industries should be included in your alerts. This means you receive targeted notifications on relevant topics. Then select further sectors if necessary. You can then select the “AND” or “OR” search. Click on the word “AND” or “OR” to change the search mode.',
	financersInfo:
		'Enter the names of the financing countries or organizations according to which your alerts should be filtered. This enables a more precise selection of suitable tenders or news. Then select other financiers if necessary. You can then select the “AND” or “OR” search. Click on the word “AND” or “OR” to change the search mode.',
	keyWordInfo:
		'Define one or more keywords that are relevant for your alerts. Click the Enter key after each search word and then enter further search words if necessary. You can then select the “AND” or “OR” search. Click on the word “AND” or “OR” to change the search mode.',
	timeInfo: 'Time at which the alerts are sent.',
	andOperator: 'AND',
	orOperator: 'OR',
	nameInfo: 'Choose a meaningful name for your alert. This will also be used in the e-mail notifications.',
	courseAlertTitle: 'MATFLIXX Price Alert',
	courseAlertGlance: 'Your personal price alerts at a glance',
	courserDescription: 'This page shows all your individual price alerts. Keep an eye on',
	courseMarket: 'price changes and market movements',
	courseChange: 'at all times and react immediately to any important developments.',
	customizable: 'Customizable',
	automaticNotifications: 'Automatic notifications',
	efficientMarketMonitoring: 'Efficient market monitoring',
	courseAdvantage: 'Your advantage: React quickly to market fluctuations and ensure you get the best conditions.',
	courseAlertStep: 'How to set up a MATFLIXX price alert',
	courseStepOne: 'Navigate to the charting area – ',
	courseStepOneDescription: 'Open the chart of the desired material in MATFLIXX.',
	courseStepTwo: 'Click on “Set up price alert” – ',
	courseStepTwoDescription: 'This button is located at the bottom left below the chart.',
	courseStepThree: 'Select comparison value – ',
	courseStepThreeDescription: 'Determine the price at which you would like to be notified.',
	courseStepFour: 'Receive notification – ',
	courseStepFourDescription: 'As soon as the price reaches your defined level, you will receive an e-mail in your mailbox.',
	courseStepFive: 'Edit or delete alerts at any time – ',
	courseStepFiveDescription: ' Navigate to “Alerts” in the main menu.',
	courseAlertStayUp: 'Always stay up to date - with the Matflixx Price Alert!',
	contactUsAndFeedback: 'If you have any questions, please do not hesitate to contact us. We look forward to your feedback.',
	newsAlertTitle: 'MATFLIXX News Alert',
	newsAlertGlance: 'Your personal news alerts at a glance',
	newsDescription: 'This page shows your individual',
	newsMarket: 'news alerts',
	newsChange: 'and explains how to set them up. Stay informed about ',
	newsSales: 'market developments, industry trends and important news',
	allTimes: 'at all times.',
	newsAlertAdvantage: 'Your advantage: React quickly to important developments and make the best decisions.',
	newsAlertStep: 'How to set up a MATFLIXX news alert',
	directlyOnThisPage: 'Directly on this page:',
	newsStepOne: 'Click “+New Alert”',
	newsStepTwo: 'Define setting – ',
	newsStepTwoDescription:
		'Specify a name for your new alert. This will appear in your notification email. Select search words or categories (“AND” or “OR” search possible), as well as the dispatch time. If you do not specify a time, you will receive new alerts separately  by e-mail immediately upon release.',
	whenReadingAnArticle: 'When reading an article:',
	newsStepThree: 'Click the "((!))" button – ',
	newsStepThreeDescription: 'Use the blue alert button on the right above an article.',
	newsStepFourDescription:
		'Specify a name for your new alert. This will appear in your notification email. The categories of the respective article are already preselected. You can deselect categories. Select further search terms or categories (“AND” or “OR” search possible), as well as the time of dispatch. If you do not specify a time, you will receive new alerts individually by e-mail immediately.',
	newsNote: '💡 Note: You can create more than one alert by repeating the process as often as you like.',
	newsStayUp: 'Stay well informed - with the Matflixx news alert!',
	tenderAlertTitle: 'MATFLIXX Tender Alert',
	pjeAlertTitle: 'MATFLIXX Early Project Information Alert',
	tenderGlance: 'Your personal alerts at a glance',
	tenderDescription:
		'Keep track of current investment and development projects as well as international tenders. Thanks to personalized notifications, you receive relevant information directly by e-mail - including further contact addresses and contacts.',
	tenderAdvantage: "📩 Always one step ahead - with Matflixx's international tender alerts!",
	tenderAlertStep: 'How to set up your alert',
	tenderStepTwoDescription:
		' Specify a name for your new alert. This will appear in your notification email. Select countries, sectors, financiers and search terms (“AND” or “OR” search possible), as well as the time of dispatch. If you do not specify a time, you will receive new alerts separately and immediately upon release by e-mail.',
	tenderStepThree: 'Add – ',
	tenderStepThreeDescription: 'You will be informed by email and by an orange dot in Matflixx.',
	whenReadingTenderText: 'When reading a tender text/early project information:',
	tenderStepOneReading: 'Open any ',
	tenderStepOneReadingDescription: 'tender or early project information.',
	tenderStepTwoReadingDescription: 'Use the blue alert button at the top right above an article.',
	tenderStepThreeReadingDescription:
		' Specify a name for your new alert. This will appear in your notification email. Countries, sectors and financing are already preselected. You can delete or change these if necessary (“AND” or “OR” search possible). You can also add search terms and the mailing time. If you do not specify a time, you will receive new alerts individually by e-mail immediately.',
	biMonthly: 'Bi-monthly',
	biWeekly: 'Bi-weekly',
	continually: 'Continually',
	halfYearly: 'Half-yearly',
	irregular: 'Irregular',
	costModel: 'Cost Models',
	current: 'Current',
	historic: 'Historic',
	addCostModelToOverview: 'Add Cost Model to overview',
	exportCostModel: 'Export Cost Model',
	copyToMyModels: 'Copy to my Models',
	addCostModel: 'Add Cost Model',
	addToMyModels: 'Add to my Models',
	adminDownload: 'Admin Download',
	assignModelToAUser: 'Assign Model to a User',
	deleteCostModel: 'Delete Cost Model',
	costModelSupportText: 'You have no Cost model space left. Please delete a model or contact customer support.',
	createAsMatflixxModel: 'Create as Matflixx Model',
	displayName: 'Display Name',
	rawMaterial: 'Raw Material',
	type: 'Type',
	period: 'Period',
	german: 'German',
	english: 'English',
	priority: 'Priority',
	successfullyAddedCostModelToDashboard: 'Successfully added cost model to dashboard',
	successfullyCopiedCostModelToMyModels: 'Successfully copied cost model to my models',
	successfullyDeletedCostModel: 'Successfully deleted cost model',
	deleteModel: 'Delete Model',
	createANewCostModel: 'Create a new Cost Model',
	areYouSureYouWantToDeleteYourCostModel: 'Are you sure you want to delete your cost model "{{name}}"?',
	confirmDelete: 'To confirm, please enter the name of your model<br /> and click Delete',
	areYouSureThatYourCostModel: 'Are you sure that your cost model:',
	wantToDelete: 'want to delete?',
	modifyModel: 'To modify this model you need to copy it to your models',
	copyModel: 'Copy Model',
	spaces: 'Spaces',
	pleaseContactCustomerSupportToUnlockThisElement: 'Please contact customer support to unlock this element',
	pleaseSelectValidMaterial: 'Please select a valid material',
	deleteModalPlaceholder: 'Name of the model',
	internalServerError: 'Internal server error',
	noSpaceError: 'No space available',
	modelSettings: 'Model Settings',
	addMatflixxCostModel: 'Add a Matflixx Cost model',
	generalSettings: 'General settings',
	dateFormat: 'Date Format',
	decimalSeparator: 'Decimal separator',
	defaultChartType: 'Default chart type:',
	surface: 'Surface',
	lines: 'Lines',
	barChart: 'Bar Chart',
	defaultChartColor: 'Default chart color:',
	forex: 'Forex',
	uploadFileMessage: 'Are you sure you want to upload file?',
	deleteNewsCategoryMessage: 'Are you sure you want to delete this item?',
	noSpaceAvailable: 'You have no Cost model space available.',
	contactCustomerSupport: 'Please contact customer support',
	authorization: 'Authorization',
	massAuthorization: 'Mass Authorization',
	orDragAndDropHere: 'or drag&drop here',
	percentageChangeSingle: '%-Change (Individual)',
	percentageChangeTotal: '%-Change (In total)',
	advanceMaterialCourseTime: 'Data time',
	original: 'Original',
	thisMaterialCannotBeAddedToCostModel: 'This material cannot be added to a cost model.',
	quaterly: 'Quaterly',
	carryForward: 'Carry Forward',
	includeWeekends: 'Include Weekends',
	carryForwardYesInfo: 'Days without any new data  will be filled by previous existing values',
	carryForwardNoInfo: 'Only existing data points will be exported',
	includesWeekendYesInfo: 'Weekends will be exported with their new data',
	includesWeekendNoInfo: 'New data which is updated on weekends will not be exported',
	includesForecastYesInfo: 'Forecast data points will be included in export and shown in images',
	includesForecastNoInfo: 'Forecast data points will be excluded in export and not shown in images',
	errorMessageForChartCheckbox: 'At least one data point must be selected.',
	errorMessageForChartTypeSelection: 'Please change chart type to add more prices',
	uploadErrorMessage: 'Please select a file with name "Matflixx_Berechtigungen"',
	course: 'Type',
	courseTooltipText: 'Selection of data to be displayed in charting.',
	frequencyTooltipText: 'Interval between data entries'
};
